import { styled } from "styled-components";
import theme from "../../styles/theme";
import { useState } from "react";
import CommonDataGrid from "../common/CommonDataGrid";
import AnnouncementIcon from '@mui/icons-material/Announcement';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import moment from "moment";

const MainWrap = styled.div`
    height: 100%;
    width: 100%;
    background: ${theme.color.white[100]};
    border-radius: 12px;
    padding: 0.5rem 1rem;
    .title_line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 1.25rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
        }
    }
`;
const NoticeTitle = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    li {
        line-height: 1.5rem;
        font-size: 1rem;
        height: 1.5rem;
        display: grid;
        grid-template-columns: 10rem 25rem 20rem minmax(1rem,auto);
        span {
            display: inline-block;
        }
        border-bottom:1px solid ${theme.color.black[20]};
    }
`;
const NoticeList = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    margin-top: 0.6rem;
`
const NoticeLi = styled.li`
    line-height: 2rem;
    font-size: 1.5rem;
    height: 2rem;
    display: grid !important;
    grid-template-columns: 10rem 25rem 20rem minmax(1rem,auto);
    span {
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`

const columns = [
    { field: 'reg_dt', headerName: '작성일시', width: 160, headerAlign:'center' },
    { field: 'project_nm', headerName: '과업명', width: 240, headerAlign:'center' },
    { field: 'client_nm', headerName: '발주처', width: 120, headerAlign:'center' },
    { field: 'descr', headerName: '내용', flex:1, headerAlign:'center', align:'center' },
]

const Notice = () => {

    const [list, setList] = useState([
        {id:1,reg_dt:'2023-11-13 13:01:02',project_nm:'제주시 다호북길 7 인근 4개소(유턴포함)',client_nm:'디에스피앤드',descr:'금요일까지'},
        {id:2,reg_dt:'2023-11-13 13:01:02',project_nm:'이케아 고양점 유출입조사',client_nm:'KTS엔지니어링',descr:'수요일까지'},
        {id:3,reg_dt:'2023-11-13 13:01:02',project_nm:'청주 서원보건소 일대 3개소 및 유출입조사',client_nm:'서하이앤씨',descr:'월요일까지'},
    ]);

    const setting = {
        infinite: true,
        speed: 700,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows:false,
        // vertical: true,
    }

    return (
        <MainWrap>
            <div className="title_line"><span><AnnouncementIcon />공지/알림</span><MoreVertIcon /></div>
            <div style={{width:'100%',height:'calc(100% - 3rem)'}}>
                <NoticeTitle>
                    <li>
                        <span>작성일시</span>
                        <span>과업명</span>
                        <span>발주처</span>
                        <span>내용</span>
                    </li>
                </NoticeTitle>
                <NoticeList>
                    <Slider {...setting}>
                        {list && list.map((item,index)=>{
                        <NoticeLi key={index}>
                            <span>{moment(item.reg_dt).format('YYYY-MM-DD')}</span>
                            <span>{item.project_nm}</span>
                            <span>{item.client_nm}</span>
                            <span>{item.descr}</span>
                        </NoticeLi>
                        })}
                    </Slider>
                </NoticeList>
            </div>
            {/* <Slider {...setting}>
                    <NoticeList>
                        <NoticeLi>
                            <span>2023-10-16</span>
                            <span>파주운정3택지개발지구 6개소(유턴포함)ddddsdfasdfasddddddd</span>
                            <span>(주)가나다라마바사아자차카타파하</span>
                            <span>코딩 빨리 해야함 긴급긴급</span>
                        </NoticeLi>
                    </NoticeList>
                    <NoticeList>
                        <NoticeLi>
                            <span>2023-10-16</span>
                            <span>6666666</span>
                            <span>(주)가나다라마바사아자차카타파하</span>
                            <span>코딩 빨리 해야함 긴급긴급</span>
                        </NoticeLi>
                    </NoticeList>
                    <NoticeList>
                        <NoticeLi>
                            <span>2023-10-16</span>
                            <span>99999</span>
                            <span>(주)가나다라마바사아자차카타파하</span>
                            <span>코딩 빨리 해야함 긴급긴급</span>
                        </NoticeLi>
                    </NoticeList>
                    </Slider> */}
        </MainWrap>
    )
}

export default Notice;
